const caseStore = apiServices => ({
    strict: process.env.NODE_ENV !== "production",
    namespaced: true,
    state: {
        caseTypes: [],
        caseDetails: {}
    },
    mutations: {
        setCaseTypes: (state, caseTypes) => {
            state.caseTypes = caseTypes;
        },
        setCaseDetails: (state, caseDetails) => {
            state.caseDetails = caseDetails; // eslint-disable-line no-param-reassign
        }
    },
    actions: {
        async loadCaseDetails(context, payload) {
            return apiServices.oa.case.getCaseDetails(payload.caseId).then((data) => {
                context.commit("setCaseDetails", data);
            });
        },
        async updateCaseDetails(context, payload) {
            return apiServices.oa.case.updateCaseDetails(payload).then((data) => {
                context.commit("setCaseDetails", data);
            });
        },
        async createNote(context, payload) {
            return apiServices.oa.case.createNote(payload).then((res) => {
                console.log("*************** note created ", res);
            });
        },
        async getCaseTypes(context, payload) {
            return apiServices.oa.case.getCaseTypes().then((data) => {
                let types = data.casetypes.filter(c => c.parentid == 8  && (
                    c.id == payload.subTypeId || (
                        c.type != "EVR" &&
                        c.type != "Competitor Referral" &&
                        c.type != "No OA leads" &&
                        c.type != "Other" &&
                        c.type != "OpenAgent to followup" &&
                        c.type != "Closed from Agent Portal"
                    )
                ));
                context.commit("setCaseTypes", types);
            });
        }
    }
});

export default caseStore;